import { createTheme } from '@mui/material'

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1330,
    },
  },
  typography: {
    fontFamily: '-apple-system, Roboto, sans-serif, serif',
    caption: {
      fontSize: '.88rem',
    },
    subtitle1: {
      fontFamily: 'serif',
    },
    h1: {
      fontSize: '3rem',
      fontWeight: 300,
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 300,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 300,
    },
    h4: {
      fontSize: '1.6rem',
      fontWeight: 300,
    },
    h5: {
      fontSize: '1.4rem',
      fontWeight: 300,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 300,
    },
  },
  palette: {
    primary: {
      main: '#0d5d82',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
})

export const gutter = theme.spacing.bind(theme)

export const breakpoints = theme.breakpoints.values

export const colors = theme.palette
